import React, { useMemo } from 'react'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import EmptyScreen from 'packages/ui/EmptyScreen'
import { useTable } from 'packages/ui/Table'
import TableViewBase from 'packages/ui/Table/Table'
import ScrollTable from 'components/global/CUK/ScrollTable'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'

import COLUMNS_CONFIG from './config-columns'
import { useSort } from '../store'
import useAdvertisements from '../use-advertisements'

const Table = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const {t} = useTranslation()
  const [sort, setSort] = useSort()
  const { advertisements, loading, error, fetchNextPage, shouldFetchNextPage, loadingNext } = useAdvertisements()

  const columns = useMemo(() => {
    return COLUMNS_CONFIG.filter(({ name }) => !id || (id && !['account', 'site'].includes(name)))
  }, [COLUMNS_CONFIG, id])

  const apiTable = useTable({
    rowKey: 'id',
    items: advertisements,
    loading,
    loadingNext,
    error,
    columns,
    onRowClick: advertisement => {
      navigate({ pathname: `${advertisement.id}` })
    }
  })
  if (!loading && !advertisements.length) {
    return (
      <EmptyScreen icon="wifi">{t('advertisements.no_data_filter')}</EmptyScreen>
    )
  }
  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        '&::-webkit-scrollbar ': {
          display: 'none'
        }
      }}>
      <ScrollTable collapse={id} fetchNextPage={fetchNextPage} shouldFetchNextPage={shouldFetchNextPage}>
        {loading ? (
          <TableSkeleton />
        ) : (
          <TableViewBase
            apiTable={apiTable}
            sort={{
              ...sort,
              onChange: name => {
                const column = columns.find(column => column.name === name)
                setSort(column.sortBy || column.name)
              }
            }}
          />
        )}
      </ScrollTable>
    </Stack>
  )
}

export default Table
